import React from "react";
import {
  WeaTimeRangePicker,
  WeaRangePicker,
  WeaInput,
  WeaTextarea,
  WeaSelect,
  WeaColorPicker,
  WeaCascader,
  WeaBrowser,
  WeaCheckbox,
  WeaDatePicker,
  WeaTimePicker,
  WeaDateGroup,
  WeaSelectGroup,
  WeaScope,
  WeaTools,
  WeaInputNumber,
  WeaPeriod,
  WeaUpload,
  WeaRichText,
  WeaTagGroup,
  WeaLocaleProvider,
  WeaInputSearch
} from "ecCom";
const WeaCustomField = WeaCascader.WeaCustomField;
const getLabel = WeaLocaleProvider.getLabel;
import isEmpty from "lodash/isEmpty";
import toNumber from "lodash/toNumber";
import isNaN from "lodash/isNaN";
import isString from "lodash/isString";
import endsWith from "lodash/endsWith";

const types = WeaTools.types;
const getKey = WeaTools.getKey;
import { observer } from "mobx-react";
const toJS = mobx.toJS;
import * as util from "../util";
import "./style/index.less";

@observer
class Main extends React.Component {
  render() {
    const { fieldConfig, form } = this.props;
    return this.renderComs(toJS(fieldConfig, true), form);
  }
  onChange(key, args) {
    let obj = {
      value: args[0] || ""
    };
    if (typeof args[0] === "number" || typeof args[0] === "boolean") {
      obj = {
        value: args[0]
      };
    }
    if (args[1]) obj.valueSpan = args[1];
    if (args[2]) obj.valueObj = args[2];
    let res = {};
    res[key] = obj;

    this.props.onChange && this.props.onChange(res, obj);
  }
  onBlur(key, value) {
    let obj = {
      value
    };
    let res = {};
    res[key] = obj;
    this.props.onBlur && this.props.onBlur(value, res, obj);
  }
  onSearch(key, value) {
    let obj = {
      value
    };
    let res = {};
    res[key] = obj;
    this.props.onSearch && this.props.onSearch(value, res, obj);
  }
  onEnterSearch(key, value) {
    let obj = {
      value
    };
    let res = {};
    res[key] = obj;
    // 支持input框onEnter事件走高级搜索的onSearch搜索方法
    const { onEnterSearch } = this.props;
    typeof onEnterSearch === "function" && onEnterSearch(value, res, obj);
  }
  renderComs(c, form) {
    //config obj text record index

    if (!c.conditionType) {
      // console && console.warn(c, `WeaSwitch渲染出错！ ${c.label} conditionType未定义`);
      console &&
        console.warn(
          c,
          `${getLabel(385069, "WeaSwitch渲染出错") +
            " " +
            c.label +
            " " +
            getLabel(385070, "conditionType未定义")}`
        );
      return <div className="wea-hide">{c.label}</div>;
    }
    const type = c.conditionType.toUpperCase();
    const key = getKey(c);
    const bindObj = form.$(key);
    if (bindObj == undefined) {
      // console && console.warn(c, `WeaSwitch渲染出错！ ${c.label} conditionType未定义`);
      console &&
        console.warn(
          c,
          `${getLabel(385069, "WeaSwitch渲染出错") +
            " " +
            c.label +
            " " +
            getLabel(385070, "conditionType未定义")}`
        );
      return <div className="wea-hide">{c.label}</div>;
    }
    delete c.value;
    const { className } = this.props;
    if (className) c.className = className;
    if (type === types.INPUT) {
      return (
        <WeaInput
          {...c}
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          onBlur={value => this.onBlur(key, value)}
          onEnterSearch={value => this.onEnterSearch(key, value)}
          value={bindObj.value}
          {...c.otherParams}
        />
      );
    }

    if (type === types.PASSWORD) {
      return (
        <WeaInput
          {...c}
          {...bindObj.bind()}
          onChange={(...args) => {
            this.onChange(key, args);
            bindObj.onChange(...args);
          }}
          onEnterSearch={value => this.onEnterSearch(key, value)}
          value={bindObj.value}
          type="password"
          {...c.otherParams}
        />
      );
    }

    if (type === types.BROWSER) {
      const showDropMenu =
        c.browserConditionParam &&
        (c.browserConditionParam.type == "4" ||
          c.browserConditionParam.type == "164"); //部门分部显示维度菜单
      if (c.browserConditionParam && c.browserConditionParam.replaceDatas) {
        delete c.browserConditionParam.replaceDatas; // 删掉默认的配置，读取form的值
      }
      return (
        <WeaBrowser
          layout={WeaTools.WindowFunc.getTop().document.body}
          showDropMenu={showDropMenu}
          {...bindObj.bind()}
          {...c.browserConditionParam}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          replaceDatas={toJS(bindObj.valueObj)}
          {...c.otherParams}
          mr0
        />
      );
    }

    if (type === types.CHECKBOX) {
      return (
        <WeaCheckbox
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.SWITCH) {
      return (
        <WeaCheckbox
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
          display="switch"
        />
      );
    }

    if (type === types.DATEPICKER) {
      return (
        <WeaDatePicker
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
          formatPattern={c.formatPattern || 2}
        />
      );
    }

    if (type === types.TIMEPICKER) {
      return (
        <WeaTimePicker
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
          formatPattern={c.formatPattern || 3}
        />
      );
    }

    if (type === types.COLORPICKER) {
      return (
        <WeaColorPicker
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.SELECT) {
      return (
        <WeaSelect
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...toJS(c)}
          {...toJS(c.otherParams)}
        />
      );
    }

    if (type === types.TEXTAREA) {
      return (
        <WeaTextarea
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          onBlur={value => this.onBlur(key, value)}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.DATE) {
      let datas = [
        { value: "0", name: getLabel(332, "全部") },
        { value: "1", name: getLabel(15537, "今天") },
        { value: "2", name: getLabel(15539, "本周") },
        { value: "3", name: getLabel(15541, "本月") },
        { value: "4", name: getLabel(21904, "本季") },
        { value: "5", name: getLabel(15384, "本年") },
        { value: "7", name: getLabel(27347, "上个月") },
        { value: "8", name: getLabel(81716, "上一年") },
        { value: "6", name: getLabel(32530, "指定日期范围") }
      ];
      if (!isEmpty(c.options)) {
        datas = [];
        c.options.forEach(o => {
          datas.push({
            value: o.key,
            name: o.showname
          });
        });
      }
      return (
        <WeaDateGroup
          {...bindObj.bind()}
          value={toJS(bindObj.value)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
          isMobx
          datas={datas}
        />
      );
    }

    if (type === types.SELECT_LINKAGE) {
      return (
        <WeaSelectGroup
          {...bindObj.bind()}
          value={util.toJS(bindObj.value, true)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
          isMobx
          mr0
        />
      );
    }

    if (type === types.SCOPE) {
      return (
        <WeaScope
          style={{ width: "100%" }}
          {...bindObj.bind()}
          value={toJS(bindObj.value)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
          isMobx
        />
      );
    }

    if (type === types.TIMERANGEPICKER) {
      return (
        <WeaTimeRangePicker
          {...bindObj.bind()}
          value={toJS(bindObj.value)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.RANGEPICKER) {
      return (
        <WeaRangePicker
          {...bindObj.bind()}
          value={toJS(bindObj.value)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.CASCADER) {
      return (
        <WeaCascader
          {...bindObj.bind()}
          values={toJS(bindObj.value)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.CASCADERCUSTOMFIELD) {
      return (
        <WeaCustomField
          {...bindObj.bind()}
          values={toJS(bindObj.value)}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.INPUTNUMBER) {
      // fix 0 不显示
      let v =
        !!bindObj.bind().value && !isNaN(toNumber(bindObj.bind().value))
          ? toNumber(bindObj.bind().value)
          : "";
      // show default value 0
      if (bindObj.bind().value === 0) v = 0;
      // show last decimal point and 0
      if (isString(bindObj.bind().value)) {
        v =
          endsWith(bindObj.bind().value, ".") ||
          endsWith(bindObj.bind().value, "0")
            ? bindObj.bind().value
            : v;
      }

      // fix first '-' disappare
      if (bindObj.bind().value == "-") {
        v = bindObj.bind().value;
      }
      return (
        <WeaInputNumber
          {...bindObj.bind()}
          value={v}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          onBlur={value => this.onBlur(key, value)}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.INPUTSEARCH) {
      return (
        <WeaInputSearch
          {...bindObj.bind()}
          value={toJS(bindObj.value)}
          onSearch={(...args) => {
            this.onSearch(key, args);
          }}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          onBlur={value => this.onBlur(key, value)}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.PERIOD) {
      return (
        <WeaPeriod
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.UPLOAD) {
      return (
        <WeaUpload
          {...bindObj.bind()}
          onChange={(...args) => {
            if (args[0]) {
              args[0] = args[0].join(",");
            }
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          datas={toJS(bindObj.valueSpan || [])}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.RICHTEXT) {
      return (
        <WeaRichText
          {...bindObj.bind()}
          onChange={(...args) => {
            bindObj.onChange(...args);
            this.onChange(key, args);
          }}
          {...c}
          {...c.otherParams}
        />
      );
    }

    if (type === types.TAGGROUP) {
      return (
        <WeaTagGroup
          {...bindObj.bind()}
          onChange={(datas, value) => {
            bindObj.onChange(value, datas);
            this.onChange(key, [value, datas]);
          }}
          {...c}
          label={""}
          {...c.otherParams}
          datas={toJS(bindObj.valueSpan || [])}
        />
      );
    }

    if (type === types.DESCRIPTION) {
      return (
        <div
          className="wea-discription-wrapper"
          dangerouslySetInnerHTML={{ __html: bindObj.value }}
        />
      );
    }
    return (
      <WeaInput
        {...bindObj.bind()}
        onEnterSearch={value => this.onEnterSearch(key, value)}
      />
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./comMobx/wea-switch/index.js